export const restEndPoints = {
  accounting: [
    {
      contacts: {
        getContactsData: 'api/contacts/allContacts',
        getContactsCount: 'api/contacts/allContactsCount',
        getContactsById: 'api/contacts/getprofilebyId',
        saveContact: 'api/contacts/profileUpdatebyId',
        deleteContact: 'api/contacts/delete',
        getContactLogs: 'api/contacts/loglines',
        updateContactLogData: 'api/contacts/loglines',
        importAccountingData: 'api/contacts/import',
      },
      invoice: {
        getInvoiceData: 'api/invoices/getAllFinMutations',
        getMutationEntriesByFinanceMutationId: 'api/invoices/mutations/entries',
        getFinanceEntrylinesByFinanceMutationId:
          'api/invoices/mutations/entries/entrylines',
        getInvoiceLogs: 'api/invoices/loglines',
        getInvoiceById: 'api/invoices/mutations/getFinanceMutationsbyId/id',
        saveEolContactId: 'api/invoices/mutations/updateEolContactId',
        updateInvoiceLogData: 'api/invoices/loglines',
        importInvoiceData: 'api/invoices/mutations/import',
      },
      stripe: {
        getStripeData: 'api/stripeTransactions/stripeData',
        getStripeFeeData: 'api/stripeTransactions/stripeFeeData',
        getStripeLogsById: 'api/stripeTransactions/logsbyStripeTransId',
        searchInStripe: 'api/stripeTransactions/searchParams',
      },
    },
  ],
  bookings: {
    getAllBookingData: 'api/bookings/bookingsDetails',
    getBookingDetails: 'api/bookings/bookingsData',
    getAllBookingDataCount: 'api/bookings/bookingsDataCount',
    getbookingDetailsbyTaskid: 'api/bookings/bookingDetailsbyTaskid',
    getbookingsImagesbyTaskid: 'api/bookings/bookingsImagesbyTaskid',
  },
  reviews: {
    getReviewData: 'api/reviews/reviewData',
    getReviewDataCount: 'api/reviews/reviewsDataCount',
    getPercentileOfReviewByGrouped:
      'api/reviews/reviewsPercentageGroupedbyStore',
    getGridReviewDetails: 'api/reviews/reviewDetails',
  },
  authuthetication: {
    changePassword: 'api/auth/changePassword',
    resetPassword: 'api/auth/forgotPassword',
    validateLogin: 'api/auth/validateLogin',
    screenbyOrg: 'api/auth/companyList',
    auth: 'api/auth/login',
  },
  clients: {
    getCompaniesDetails: 'api/companies/details',
    getCompaniesById: 'api/companies/id',
    saveCompany: 'api/companies/insert',
    generateKeys: 'api/companies/connect',
  },
};
